import React from 'react'
import emoji from 'react-easy-emoji'
import ItemPicker from './ItemPicker'
import { getStickerUrl } from 'core/utils'

/* list of emoji's sourced from http://getemoji.com */
const EMOJI = {
  PEOPLE: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '😇', '🤣', '☺️', '😊', '🙂', '🙃', '😉', '😌', '🤩', '😍', '😘', '😗', '😙', '😚', '😋', '😜', '😝', '😛', '🤑', '🤗', '🤓', '😎', '🤡', '🤠', '😏', '😒', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖', '😫', '😩', '😤', '😠', '😡', '😶', '😐', '😑', '😯', '😦', '😧', '😮', '😲', '😵', '😳', '😱', '😨', '😰', '😢', '😥', '🤤', '😭', '😓', '😪', '😴', '🙄', '🤔', '🤥', '😬', '🤐', '🤢', '🤧', '😷', '🤒', '🤕', '😈', '👿', '💩', '👻', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '👨', '👩', '👱‍♀️', '👰', '💏', '👩‍❤️‍💋‍👨', '👨‍❤️‍💋‍👨', '👩‍❤️‍💋‍👩', '💑', '👩‍❤️‍👩', '👨‍❤️‍👨'],
  LOVE: ['❤️', '💜', '💙', '🧡', '💛', '💚', '🖤', '💓', '💟', '💔', '💕', '💝', '💖', '💗', '💞', '💘', '♥️', '🎊', '🎉', '🎁', '💝', '💐', '💎', '💍', '🕯️', '✉️', '📨', '📩', '💌', '🏳️‍🌈', '🔥', '🌸', '🌺', '🌼', '🌹', '🌻', '🌷', '🐰', '⭐', '🌟', '🌠'],
  HANDS: ['👐', '🙌', '👏', '🙏', '🤝', '👍', '👎', '👊', '✊', '🤛', '🤜', '🤞', '✌️', '🤘', '👌', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐', '🖖', '👋', '🤙', '💪', '🖕', '✍️', '🤳', '💅', '🖖'],
  OTHER: ['💄', '💋', '👄', '👅', '👂', '👃', '👣', '👁', '👀', '👗', '👠', '👞', '👟', '👒', '🎩', '🎓', '👑', '⛑', '🎒', '👝', '👛', '👜', '💼', '👓', '🕶', '☂️'],
}
const ALL_EMOJI = [].concat(...Object.values(EMOJI))

const Emoji = ({ name, ...props }) => <div {...props}>{emoji(name)}</div>

export const EmojiPicker = ({ onSelect, label }) => (
  <ItemPicker items={ALL_EMOJI} type="emoji" Item={Emoji} label={label} icon="emoji" onSelect={onSelect}/>
)

const STICKERS = {
  cat: ['cat_717', 'cat_9ep', 'cat_9ut', 'cat_asu', 'cat_b9f', 'cat_bp9', 'cat_ddb', 'cat_bno'],
  common: ['yeah', 'dynamite', 'ass', 'grab', 'photo', 'wink', 'hey', 'hot', 'nudes', 'kiss', 'handcuffs', 'omg', ['heart', 'heartbroken'], 'doggy', 'bed', 'alone', 'cocktail', 'dirty', 'tease'],
  man: ['man_horny', 'man_naked', 'man_tattoos'],
  woman: ['woman_horny', 'woman_naked', 'woman_tattoos'],
  gayMan: ['man_easy', 'man_nudes', 'man_play', 'man_sex', 'man_spank'],
  gayWoman: ['woman_gog'],
  get: types => (localStorage.ccpUseCats ? STICKERS.cat : []).concat(...types.map(type => STICKERS[type])).filter((e, i, a) => e && a.indexOf(e) == i),
}

const Sticker = ({ name, ...props }) => <img alt={name} src={getStickerUrl(name)} {...props} className={`sticker sticker-${name}`}/>

export const StickerPicker = ({ onSelect, label, stickers }) => (
  <ItemPicker items={STICKERS.get(stickers)} type="sticker" Item={Sticker} label={label} icon="stickers" onSelect={onSelect}/>
)
